import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'hearingEndTime',
  pure: true,
})
export class HearingEndTimePipe implements PipeTransform {
  constructor() {}

  transform(value: Date, duration: number): Date {
    const startTime = new Date(value);
    let endDate = startTime;
    endDate.setMinutes(startTime.getMinutes() + duration);
    return endDate;
  }
}
